export default function (price, noValue = '-') {
  if (
    price &&
    price.amount !== undefined &&
    price.amount !== null &&
    !isNaN(price.amount) &&
    (price.amount || price.allowZero)
  ) {
    var prefix = price.currency
    switch (price.currency) {
    case 'USD':
      prefix = 'US$'
      break
    case 'AUD':
      prefix = 'A$'
      break
    case 'ZAR':
      prefix = 'R'
      break
    }
    return (
      prefix +
      ' ' +
      price.amount.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    )
  } else {
    return noValue
  }
}
